import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RamLayerGroup, RamLayerOption } from '../visor.types';

interface LayerGroupViewModel {
  label: RamLayerGroup;
  layers: RamLayerOption[];
}

const LAYER_GROUP_ORDER: RamLayerGroup[] = ['General', 'Guarda', 'Comunero', 'Riego'];

@Component({
  selector: 'app-layer-control',
  imports: [FormsModule],
  templateUrl: './layer-control.component.html',
  styleUrl: './layer-control.component.scss'
})
export class LayerControlComponent {
  @Input({ required: true }) layers: RamLayerOption[] = [];
  @Input() visible = false;
  @Input() grouped = false;
  @Input() featureInfoActive = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() featureInfoActiveChange = new EventEmitter<boolean>();
  @Output() zoomInRequested = new EventEmitter<void>();
  @Output() zoomOutRequested = new EventEmitter<void>();
  @Output() layerToggled = new EventEmitter<{ layer: RamLayerOption; enabled: boolean }>();

  protected get displayLayers(): RamLayerOption[] {
    return [...this.layers].sort((first, second) => first.panelOrder - second.panelOrder);
  }

  protected get layerGroups(): LayerGroupViewModel[] {
    return LAYER_GROUP_ORDER
      .map((label) => ({
        label,
        layers: this.layers
          .filter((layer) => layer.group === label)
          .sort((first, second) => first.panelOrder - second.panelOrder)
      }))
      .filter((group) => group.layers.length > 0);
  }

  protected zoomIn(): void {
    this.zoomInRequested.emit();
  }

  protected zoomOut(): void {
    this.zoomOutRequested.emit();
  }

  protected toggleVisible(): void {
    this.visibleChange.emit(!this.visible);
  }

  protected toggleFeatureInfo(): void {
    this.featureInfoActiveChange.emit(!this.featureInfoActive);
  }

  protected close(): void {
    this.visibleChange.emit(false);
  }

  protected toggleLayer(layer: RamLayerOption, enabled: boolean): void {
    this.layerToggled.emit({ layer, enabled });
  }
}
